import Siprec from './factory/Siprec'
import Locale from '@/locale'
import Format from '@/utils/Format'
import Record from '@/models/Record'

const pdFields = [
  'id', 'callDate', 'source', 'destination', 'fileName', 'encrypted', 'codecType', 'duration'
]

export default Siprec({
  name: 'dataChanges',
  enums: {
    operation: {
      CREATE: 'CREATE',
      READ: 'READ',
      UPDATE: 'UPDATE',
      DELETE: 'DELETE',
      PLAY: 'PLAY',
      DOWNLOAD: 'DOWNLOAD'
    },
    tableName: {
      SIPREC_USER: Locale.t('titles.admin.users'),
      SIPREC_TAG: Locale.t('titles.admin.tags'),
      SIPREC_USER_CERTIFICATE: Locale.t('titles.admin.userCertificates'),
      SIPREC_COMPANY: Locale.t('titles.admin.companies'),
      SIPREC_COMPANY_GROUP: Locale.t('titles.admin.companyGroups'),
      SIPREC_COMPANY_DELEGATION: Locale.t('titles.admin.companyDelegations'),
      SIPREC_CONFIGURATION: Locale.t('titles.admin.configuration'),
      SIPREC_TARGET_GROUP: Locale.t('titles.admin.lineGroups'),
      SIPREC_TARGET: Locale.t('titles.admin.lines'),
      SIPREC_NUMBER: Locale.t('titles.admin.numbers'),
      SIPREC_ACCESS: Locale.t('titles.reports.accesses')
    }
  },
  methods: {
    getDiff (item, field) {
      try {
        let result = JSON.parse(item[field])
        if (!result) return []
        let other = field === 'dataBefore' ? 'dataAfter' : 'dataBefore'
        let otherResult = JSON.parse(item[other])
        if (!otherResult) otherResult = {}

        // Special case for play/download operations
        let playDownload = field === 'dataBefore' && (item.operation === 'PLAY' || item.operation === 'DOWNLOAD')

        return Object.keys(result)
          .filter(field => {
            if (playDownload) {
              return pdFields.indexOf(field) >= 0
            }

            if (typeof result[field] === 'object') {
              if (otherResult[field] === result[field] ||
                (!otherResult[field] && !result[field])
              ) {
                return false
              }

              if ((!otherResult[field] && result[field]) ||
                (otherResult[field] && !result[field])
              ) {
                return true
              }

              if (Array.isArray(result[field])) {
                return result[field].length !== otherResult[field].length || !!result[field].find((item, index) => {
                  otherResult[field][index] !== item
                })
              } else {
                return false
              }
            }

            return result[field] !== otherResult[field]
          })
          .map(field => {
            let value = result[field]

            if (field === 'certificate' || field === 'encryptionKey') {
              value = '****'
            }

            if (Array.isArray(value)) {
              value = `[${value.join(',')}]`
            }

            if (playDownload) {
              if (field === 'callDate') {
                value = Format.date(value)
              }

              if (field === 'fileName') {
                value = Record.getFilename(result)
              }

              if (field === 'duration') {
                value = Format.interval(value)
              }
            }

            return `${field}: ${value}`
          })
      } catch (e) {
        console.error(e)
        return []
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/DataChange.js